export default "__VITE_ASSET__DkxBMfFC__"